import styled from 'styled-components';

interface CheckboxProps {
  color?: string;
}

interface OptionContainerProps {
  isSelected?: boolean;
}

export const Checkbox = styled.input.attrs({
  className: 'Checkbox',
  type: 'checkbox',
})<CheckboxProps>(
  ({ color }) => `  
    margin: 0 2px;
    cursor: pointer;
    accent-color: ${color};
  `
);

export const LabelsContainer = styled.div.attrs({
  className: 'LabelsContainer',
})`
  background: #192225;
  display: flex;
  flex-direction: column;
  width: 300px;
  border-radius: 5px;
  gap: 10px;
  color: #ffffff;
`;

export const FeatureContainer = styled.div.attrs({
  className: 'FeatureContainer',
})`
  background: #192225;
  border-radius: 5px;
  display: flex;
  flex-direction: column;
  gap: 5px;
  margin: 0 10px;
`;

export const FeatureOptionsContainer = styled.div.attrs({
  className: 'FeatureOptionsContainer',
})`
  display: flex;
  flex-direction: column;
  padding-bottom: 10px;
`;

export const FeatureTitle = styled.div.attrs({
  className: 'FeatureTitle',
})`
  border-radius: 5px 10px 0 0;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 15px;
  flex-direction: column;
  &:after {
    content: '';
    height: 5px;
    width: 80%;
    border-bottom: 1px solid gray;
  }
`;

export const FeatureDropdownContainer = styled.div.attrs({
  className: 'DropdownContainer',
})`
  display: flex;
  flex-direction: column;
  gap: 5px;
`;

export const OptionContainer = styled.div.attrs({
  className: 'OptionContainer',
})<OptionContainerProps>(
  ({ isSelected }) => `
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 0.75em 1em;
    cursor: pointer;
    font-size: 12px;
    background: ${isSelected ? 'lightpink' : 'none'};
    &:hover {
      background: ${isSelected ? 'pink' : 'lightgray'};
    }
  `
);
